module.exports = __webpack_public_path__ + "img/robo-lite.bfbd15c8.png";